import React, { useState, forwardRef, useImperativeHandle, useContext } from 'react';
import { userContext } from '../../utils/user';
import { APIs } from '../../utils/constants';
import { AuthFetch } from '../auth-fetch';
import { Form, Input } from 'antd';
import ModalWithAlert from './modal';
import Button from '../button';
import Text from '../text';

const EditName = forwardRef((_, ref) => {
    const user = useContext(userContext);
    const [form] = Form.useForm();
    const formInitialValues = {
        name: user.user.fullname
    }
    const initialFields = [
        {
            name: ['name'],
            value: user.user.fullname
        }
    ];

    // States
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalAlerts, setModalAlerts] = useState([]);
    const [fields, setFields] = useState(initialFields);

    // Actions
    useImperativeHandle(ref, () => ({
        showModal() {
            setIsModalVisible(true);
        }
    }))

    const handleModalClose = () => {
        setIsModalVisible(false);
        setFields(initialFields);
    }

    const handleErrorAlerts = () => {
        setModalAlerts([
            ...modalAlerts,
            {
                type: 'error',
                content: <Text id='modal::edit-name::message::error' />
            }
        ]);
    };

    const handleModalSubmit = () => {
        form
            .validateFields()
            .then(async values => {
                try {
                    const response = await AuthFetch(APIs.EDIT_NAME, {
                        method: 'POST',
                        body: JSON.stringify({
                            name: values.name.trim(),
                            user: user.user.id,
                            token: user.user.deviceIdentity
                        })
                    });
                    await response.json();
                    if (response.ok) {
                        const userBackup = { ...user.user };
                        userBackup['fullname'] = values.name.trim();
                        user.updateUser(userBackup);
                        initialFields[0].value = values.name.trim();
                        handleModalClose();
                    } else {
                        handleErrorAlerts();
                    }
                } catch (error) {
                    handleErrorAlerts();
                }
            })
    }

    return (
        <ModalWithAlert
            title={<Text id='modal::edit-name::title::edit-name' />}
            visible={isModalVisible}
            onCancel={handleModalClose}
            alerts={modalAlerts}
            footer={[
                <Button key='submit' onClick={handleModalSubmit}>
                    <Text id='modal::edit-name::button::save' />
                </Button>
            ]}>
            <div className='text-gray mt-3'>
                <Form
                    form={form}
                    fields={fields}
                    initialValues={formInitialValues}
                    onFieldsChange={(_, newFields) => {
                        setFields(newFields);
                    }}
                    layout='vertical'>
                    <Form.Item
                        name='name'
                        label={<Text id='modal::edit-name::text::name' />}
                        rules={[
                            { required: true, message: <Text id='modal::edit-name::error::name-required' /> }
                        ]}>
                        <Input />
                    </Form.Item>
                </Form>
            </div>
        </ModalWithAlert>
    );
})

export default EditName;
